import { Location } from '@angular/common';
import { Component, HostListener, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { AccountingSystemEnums, TypeAccountingSystemEnums } from 'src/app/enum/accouting-system-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { BussinessDocumentsClassEnums } from './../../../../enum/bussiness-documets-class-enums';
import { AccountingInterfaceModel } from './../../../../models/invoicing/accounting-interface.model';
import { AccountingInterfaceService } from './../../../../services/invoicing/accounting-interface.service';
import { EnterpriseService } from './../../../../services/management/enterprise.service';

@Component({
  selector: 'app-register-accounting-interface',
  templateUrl: './register-accounting-interface.component.html',
  styleUrls: ['./register-accounting-interface.component.scss'],
  standalone: false
})
export class RegisterAccountingInterfaceComponent implements OnInit {

  private readonly accountingInterfaceService = inject(AccountingInterfaceService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly branchService = inject(BranchService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly dateConverterService = inject(DateConverterService);
  private readonly domService = inject(DomSanitizer);
  private readonly enterpriseService = inject(EnterpriseService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly headerService = inject(HeaderService);
  private readonly location = inject(Location);
  private readonly optionWindowService = inject(OptionWindowService);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  accountingInterfaceContract: AccountingInterfaceModel = new AccountingInterfaceModel();
  accountingInterfaceId: number = 0;
  branchId: number = 0;
  bussinessDocumentsTypeId: number = BussinessDocumentsClassEnums.factura;
  companyId: number = 0;
  disabledActions: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  enterpriseId: number = 0;
  public formAccountingInterface: FormGroup = new FormGroup({});
  iconState: string = "pi pi-lock-open";
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listBussinessDocumentsTypes: any[] = [];
  listEnterprises: any[] = [];
  nameWindow: string = 'Captura Interfaz';
  permissionsUser: OptionWindowModel[] = [];
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = "danger";
  stateText: string = 'Abierto';
  subscription: Subscription;
  titleState: string = "";
  typeInterface: string = '';
  url: string = "accounting-interface";
  userAuthenticated: UserModel = new UserModel();
  visibleExportCxc: boolean = false;
  visibleState: boolean = false;
  siesaSynchronization: boolean = false;
  
  async ngOnInit() {
    await this.validateForm(new AccountingInterfaceModel());
    await this.getPermission();
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    this.activatedRoute.params.subscribe(params => {
      this.accountingInterfaceId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  changeSelection() {
    this.accountingInterfaceId = 0;
    const modelAccountingInterface = new AccountingInterfaceModel();
    modelAccountingInterface.branchId = this.branchId;
    modelAccountingInterface.enterpriseId = this.enterpriseId;
    this.accountingInterfaceContract = modelAccountingInterface;
    this.validateForm(modelAccountingInterface);
  }

  async changeConsecutive() {
    const branchId = this.formAccountingInterface.get("branchId")?.value;
    const entrepriseId = this.formAccountingInterface.get("enterpriseId")?.value;
    let consecutive = this.formAccountingInterface.get("consecutive")?.value;

    if (this.accountingInterfaceContract.consecutive == consecutive) return;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }

    if (entrepriseId == null || entrepriseId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una empresa.'
      );
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      await this.resetAccountingInterface(branchId, entrepriseId);
      return;
    }

    try {
      this.accountingInterfaceContract = await firstValueFrom(
        this.accountingInterfaceService.getAccountingInterfaceByKeysAsync(branchId, entrepriseId, consecutive)
      );
      this.accountingInterfaceId = this.accountingInterfaceContract.accountingInterfaceId;
      await this.validateForm(this.accountingInterfaceContract);
    } catch (error) {
      console.error('Error al buscar la interfaz.', error);
      await this.validateForm(this.accountingInterfaceContract);
    }
  }

  async changeState() {
    if (!this.validations()) return;
    try {
      this.accountingInterfaceContract = await firstValueFrom(
        this.accountingInterfaceService.setStateAccountingInterface(this.accountingInterfaceContract.accountingInterfaceId)
      );
      await this.validateForm(this.accountingInterfaceContract);
      this.toastHandlerService.showToast(
        'success',
        'El estado de la interfaz se modificó exitosamente.'
      );
    } catch (error) {
      console.error('Error al cambiar el estado de la interfaz.', error);
    }
  }

  async createNewAccountingInterface() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para crear interfaz. Comuníquese con el administrador del sistema.',
      );
      return;
    }

    this.accountingInterfaceId = 0;
    this.accountingInterfaceContract = new AccountingInterfaceModel();
    this.accountingInterfaceContract.branchId = this.branchId;
    this.accountingInterfaceContract.enterpriseId = this.enterpriseId;
    this.quantityDetails = 0;
    await this.validateForm(this.accountingInterfaceContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async deleteAccountingInterface() {
    if (!this.validations()) return;

    if (!this.accountingInterfaceContract.active) {
      this.toastHandlerService.showToast(
        'warning',
        'La interfaz se encuentra cerrada.',
      );
      return;
    }

    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible eliminar, la interfaz tiene detalle.'
      );
      return;
    }

    if (await this.confirmDialogService.confirm(
      `¿Realmente desea eliminar la interfaz ${this.accountingInterfaceContract.consecutive}?`
    )) {
      try {
        await firstValueFrom(
          this.accountingInterfaceService.deleteAccountingInterface(this.accountingInterfaceContract.accountingInterfaceId)
        );
        this.toastHandlerService.showToast(
          'success',
          'La interfaz fue eliminada exitosamente.'
        );
        this.createNewAccountingInterface();
      } catch (error) {
        console.error('Error al eliminar la interfaz.', error);
      }
    }
  }

  async exportCxC() {
    if (this.accountingInterfaceContract.active) {
      this.toastHandlerService.showToast(
        'warning',
        'La interfaz debe estar cerrada para exportar.',
      );
      return;
    }
    const fileName = `Cervino_${this.accountingInterfaceContract.consecutive}`;
    if (this.accountingInterfaceContract.accountingInterfaceId != 0) {
      try {
        const downloadedFile = await firstValueFrom(
          this.accountingInterfaceService.exportCxc(this.accountingInterfaceContract.accountingInterfaceId)
        );
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = fileName;
        a.href = URL.createObjectURL(downloadedFile);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      } catch (error) {
        console.error('Error al exportar la interfaz CxC.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Interfaz valida.'
      );
    }
  }

  async getAccountingInterfaceById() {
    try {
      this.accountingInterfaceContract = await firstValueFrom(
        this.accountingInterfaceService.getAccountingInterfaceById(this.accountingInterfaceId)
      );
      this.accountingInterfaceId = this.accountingInterfaceContract.accountingInterfaceId;
      this.branchId = this.accountingInterfaceContract.branchId;
      this.enterpriseId = this.accountingInterfaceContract.enterpriseId;
      await this.validateForm(this.accountingInterfaceContract);
    } catch (error) {
      console.error('Error al buscar la interfaz.', error);
    }
  }

  async getAllLists() {
    try {
      const [branches, enterprises] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getAllEnterprisesForSelectAsync()),
      ]);
      this.listBranches = branches;
      this.listEnterprises = enterprises;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getButtonClick(buttonClick: any) {
    let consecutive = this.formAccountingInterface.get("consecutive")?.value;
    const branchId = this.formAccountingInterface.get("branchId")?.value;
    const enterpriseId = this.formAccountingInterface.get("enterpriseId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }

    if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una empresa.'
      );
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    await this.handleAccountingInterfaceNavigation(buttonClick, branchId, enterpriseId, consecutive);
  }

  async getBranch(branchId: number | null, reload: boolean) {
    let validBranch = null;
    if (branchId != null) {
      try {
        const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
        if (branch) {
          validBranch = branchId;
        }
      } catch (error) {
        console.error('Error al obtener la sucursal.', error);
      }
    }
    this.branchId = validBranch ?? 0;
    this.formAccountingInterface.controls["branchId"].patchValue(validBranch);
    this.getFirstEnterpriseByBranch(branchId);
    if (reload) {
      this.changeSelection();
    }
  }

  async getBussinessDocumentsTypeList(branchId: number, enterpriseId: number) {
    try {
      this.listBussinessDocumentsTypes = await firstValueFrom(
        this.accountingInterfaceService.getAllBussinessDocumentsTypesForSelectAsync(branchId, enterpriseId)
      );
    } catch (error) {
      console.error('Error al obtener la lista de tipos de documentos comerciales.', error);
    }
  }

  async getCompanyById() {
    const company = (await firstValueFrom(
      this.userAuthenticatedService.companyObservable.pipe(
        filter((company) => company && company.companyId !== 0)
      )
    ));

    if (company.typeAccountingSystemId == TypeAccountingSystemEnums.cxc) {
      this.visibleExportCxc = true;
      this.typeInterface = 'CxC';
    } else if (company.typeAccountingSystemId == TypeAccountingSystemEnums.contab) {
      this.visibleExportCxc = false;
      this.typeInterface = 'Contable';
    } else {
      this.typeInterface = '';
      this.visibleExportCxc = true;
    }

    this.siesaSynchronization = company.accountingSystemId === AccountingSystemEnums.siesaCloud;
    this.nameWindow = `${this.nameWindow} ${this.typeInterface}`;
  }

 

  async getEnterprise(enterpriseId: number | null, reload: boolean) {
    if (enterpriseId != null) {
      this.formAccountingInterface.controls["enterpriseId"].patchValue(enterpriseId);
      this.enterpriseId = enterpriseId;
      await this.getBussinessDocumentsTypeList(this.branchId, enterpriseId);
    }
    if (reload) {
      this.changeSelection();
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
      this.getBranch(response.branchId, false);
      this.companyId = response.companyId;
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario autenticado.', error);
    }
  }

  async getFirstBussinessDocumentsType(branchId: number, enterpriseId: number) {
    if (branchId != null && branchId != 0) {
      try {
        const response = await firstValueFrom(
          this.accountingInterfaceService.getFirstBussinessDocumentsTypeAsync(branchId, enterpriseId)
        );
        if (response) {
          this.formAccountingInterface.controls["bussinessDocumentsTypeId"].patchValue(response.value);
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'La empresa no tiene creado tipos de documentos comerciales.'
          );
        }
      } catch (error) {
        console.error('Error al obtener el primer tipo de documento comercial.', error);
      }
    }
  }

  async getFirstEnterpriseByBranch(branchId: number | null) {
    if (branchId != null && branchId != 0) {
      try {
        const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
        if (response) {
          this.formAccountingInterface.controls["enterpriseId"].patchValue(response.enterpriseId);
          this.enterpriseId = response.enterpriseId;
          await this.getBussinessDocumentsTypeList(branchId, response.enterpriseId);
          this.getFirstBussinessDocumentsType(branchId, response.enterpriseId);
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'La sucursal no tiene empresas creadas.',
          );
        }
      } catch (error) {
        console.error('Error al obtener la primera empresa de la sucursal.', error);
      }
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }

    await Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync(),
      this.getCompanyById()
    ]);

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
      await this.getAllLists();

    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.userAuthenticated = await firstValueFrom(
        this.userAuthenticatedService.userObservable.pipe(
          filter(user => user && user.userId !== 0)
        )
      );
      this.permissionsUser = await firstValueFrom(
        this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.AccountingInterface)
      );
    } catch (error) {
      console.error('Error al obtener los permisos del usuario por ventana.', error);
    }
  }

  async handleInitialState() {
    if (this.accountingInterfaceId !== null && this.accountingInterfaceId !== 0) {
      await this.getAccountingInterfaceById();
    } else {
      this.createNewAccountingInterface();
    }
  }

  private async handleAccountingInterfaceNavigation(buttonClick: any, branchId: number, enterpriseId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<AccountingInterfaceModel>> = {
      first: async () =>
        await firstValueFrom(
          this.accountingInterfaceService.getFirstAccountingInterfaceByKeysAsync(branchId, enterpriseId)
        ),
      previus: async () =>
        await firstValueFrom(
          this.accountingInterfaceService.getPreviusAccountingInterfaceByKeysAsync(branchId, enterpriseId, consecutive)
        ),
      next: async () =>
        await firstValueFrom(
          this.accountingInterfaceService.getNextAccountingInterfaceByKeysAsync(branchId, enterpriseId, consecutive)
        ),
      last: async () =>
        await firstValueFrom(
          this.accountingInterfaceService.getLastAccountingInterfaceByKeysAsync(branchId, enterpriseId)
        )
    };

    const actionKey = typeof buttonClick === 'string'
      ? buttonClick
      : buttonClick.target.id;

    const action = actionMap[actionKey]
    if (!action) {
      await this.resetAccountingInterface(branchId, enterpriseId);
      return;
    }

    try {
      const accountingInterface = await action();
      this.accountingInterfaceContract = accountingInterface;
      this.accountingInterfaceId = accountingInterface.accountingInterfaceId;
      await this.validateForm(accountingInterface);
      this.location.replaceState(`/${this.url}/register/${this.accountingInterfaceId}`);
    } catch (error) {
      console.error(`Error al buscar la interfaz (${buttonClick.target.id}).`, error);
    }
  }

  async resetAccountingInterface(branchId: number, enterpriseId: number) {
    this.accountingInterfaceId = 0;
    this.accountingInterfaceContract = new AccountingInterfaceModel();
    this.accountingInterfaceContract.branchId = branchId;
    this.accountingInterfaceContract.enterpriseId = enterpriseId;
    await this.validateForm(this.accountingInterfaceContract);
  }

  sanitizeImageUrl(imageUrl: string): SafeUrl {
    return this.domService.bypassSecurityTrustUrl(imageUrl);
  }

  async send(): Promise<any> {
    if (this.disabledForm) {
      this.toastHandlerService.showToast(
        'warning',
        `No es posible guardar, la interfaz NO se encuentra en estado abierto.`
      );
      return;
    }

    if (this.formAccountingInterface.valid) {
      const modelAccountingInterface = this.formAccountingInterface.getRawValue();
      //Hago null, los campos que permiten ser nulos:
      modelAccountingInterface.observation = modelAccountingInterface.observation || null;

      if (this.accountingInterfaceId == 0) {
        try {
          const response = await firstValueFrom(
            this.accountingInterfaceService.createAccountingInterface(modelAccountingInterface)
          );
          this.toastHandlerService.showToast(
            'success',
            `La interfaz fue creada exitosamente.`
          );
          this.accountingInterfaceContract = response;
          this.accountingInterfaceId = this.accountingInterfaceContract.accountingInterfaceId;
          await this.validateForm(this.accountingInterfaceContract);
          this.location.replaceState(`/${this.url}/register/${this.accountingInterfaceId}`);
        } catch (error) {
          console.error('Error al crear la interfaz.', error);
        }
      } else {
        this.accountingInterfaceContract.bussinessDocumentsTypeId = modelAccountingInterface.bussinessDocumentsTypeId;
        this.accountingInterfaceContract.dateInterface = modelAccountingInterface.dateInterface;
        this.accountingInterfaceContract.observation = modelAccountingInterface.observation;
        try {
          const response = await firstValueFrom(
            this.accountingInterfaceService.updateAccountingInterface(this.accountingInterfaceContract)
          );
          this.toastHandlerService.showToast(
            'success',
            `La interfaz fue modificada exitosamente.`
          );
          this.accountingInterfaceContract = response;
          await this.validateForm(this.accountingInterfaceContract);
        } catch (error) {
          console.error('Error al actualizar la interfaz.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo sucursal es obligatorio.',
      enterpriseId: 'El campo empresa es obligatorio.',
      bussinessDocumentsTypeId: 'El campo tipo documento comercial es obligatorio.',
      dateInterface: 'El campo fecha es obligatorio.',
      observation: 'El campo observación permite máximo 50 caracteres.'
    };

    Object.keys(controlMessages).forEach(control => {
      if (this.formAccountingInterface.controls[control].invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control]);
      }
    });
  }

  async updateFormState() {
    type StateConfig = {
      severity: string;
      icon: string;
      title: string;
      text: string;
      isDisabled: boolean;
      enableConsecutive: boolean;
    };

    let config: StateConfig;
    if (this.accountingInterfaceContract.active) {
      config = {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.accountingInterfaceId !== 0 && this.accountingInterfaceId !== null,
      };
    } else {
      config = {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        enableConsecutive: true,
      };
    }

    if (config) {
      this.severityState = config.severity;
      this.iconState = config.icon;
      this.titleState = config.title;
      this.stateText = config.text;
      this.disabledForm = config.isDisabled;
      this.disabledActions = config.isDisabled;
      this.disabledDetail = config.isDisabled;
      const enableConsecutive = config.enableConsecutive;

      this.disabledForm ? this.formAccountingInterface.disable() : this.formAccountingInterface.enable();
      const control = this.formAccountingInterface.controls["consecutive"];
      enableConsecutive ? control.enable() : control.disable();
    }
    if (!this.permissionUpdatable) setTimeout(() => this.formAccountingInterface.disable());
    this.formControlStateService.setControlState(this.formAccountingInterface, ['branchId', 'enterpriseId'], true);

  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para modificar la interfaz. Comuníquese con el administrador del sistema'
      );
      return false;
    }

    if (this.accountingInterfaceContract.accountingInterfaceId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una interfaz.'
      );
      return false;
    }
    return true;
  }

  validateForm(accountingInterface: AccountingInterfaceModel) {
    this.formAccountingInterface = this.formBuilder.group({
      branchId: [accountingInterface.branchId, [Validators.required, Validators.min(1)]],
      enterpriseId: [accountingInterface.enterpriseId, [Validators.required, Validators.min(1)]],
      consecutive: [accountingInterface.consecutive, [Validators.required]],
      active: [accountingInterface.active, []],
      bussinessDocumentsTypeId: [accountingInterface.bussinessDocumentsTypeId, [Validators.required, Validators.min(1)]],
      dateInterface: [accountingInterface.dateInterface ?
        this.dateConverterService.convertUtcToLocalDate(accountingInterface.dateInterface) : null, [Validators.required]],
      observation: [accountingInterface.observation, [Validators.maxLength(50)]]
    });
    if (accountingInterface.accountingInterfaceId == 0) {
      this.getFirstBussinessDocumentsType(this.branchId, this.enterpriseId);
    }
    this.updateFormState();
  }
}
